"use client"

import { vimeoBaseUrl } from "@/app/(site)/_components/SanityElements/constants"
import { type VideoType } from "@/types"

interface VideoProps {
    video: VideoType
}

export default function Video({ video }: VideoProps) {
    return (
        <iframe
            src={`${vimeoBaseUrl}${video.vimeoId}?badge=0&amp;player_id=0&amp;app_id=58479`}
            frameBorder="0"
            allowFullScreen
            className="h-full w-full"
            title="Video"
            loading="lazy"
            allow="autoplay; fullscreen; picture-in-picture"
        />
    )
}
